import { Link } from "react-router-dom";

export default function LegalLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-[color:var(--bg-primary)] text-[color:var(--text-primary)] py-16 md:py-24 px-6 md:px-10">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="font-heading text-2xl inline-block mb-10">Dentainhoa<span className="text-[color:var(--accent)]">.</span></Link>
        <div className="text-xs uppercase tracking-[0.28em] text-[color:var(--text-secondary)] mb-4">Documento legal</div>
        <h1 className="font-heading text-4xl md:text-6xl tracking-tighter mb-10">{title}</h1>
        <div className="prose-legal space-y-6 text-[color:var(--text-secondary)] leading-relaxed">{children}</div>
        <div className="mt-16 pt-8 border-t border-[color:var(--border-subtle)] flex flex-wrap gap-6 text-xs uppercase tracking-widest">
          <Link to="/" className="hover:text-[color:var(--accent)]">← Volver</Link>
          <Link to="/aviso-legal" className="hover:text-[color:var(--accent)]">Aviso legal</Link>
          <Link to="/privacidad" className="hover:text-[color:var(--accent)]">Privacidad</Link>
          <Link to="/cookies" className="hover:text-[color:var(--accent)]">Cookies</Link>
        </div>
      </div>
      <style>{`
        .prose-legal h2 { font-family: "Cormorant Garamond", serif; font-size: 1.75rem; color: var(--text-primary); margin-top: 2rem; margin-bottom: 0.75rem; letter-spacing: -0.02em; }
        .prose-legal p, .prose-legal li { font-size: 0.98rem; }
        .prose-legal ul { list-style: disc; padding-left: 1.25rem; display: flex; flex-direction: column; gap: 0.4rem; }
        .prose-legal strong { color: var(--text-primary); }
      `}</style>
    </div>
  );
}
